import { createFileRoute } from "@tanstack/react-router";
import { PolicyLayout, PolicySection } from "@/components/skl/PolicyLayout";

export const Route = createFileRoute("/cookiepolitik")({
  head: () => ({
    meta: [
      { title: "Cookiepolitik — SKL-Flow" },
      { name: "description", content: "Sådan bruger SKL-Flow cookies og lignende teknologier på vores hjemmeside." },
      { name: "robots", content: "index,follow" },
      { property: "og:title", content: "Cookiepolitik — SKL-Flow" },
      { property: "og:description", content: "Information om cookies på sklflow.com — formål, typer og dine valg." },
      { property: "og:type", content: "article" },
    ],
    links: [{ rel: "canonical", href: "https://sklflow.com/cookiepolitik" }],
  }),
  component: Cookiepolitik,
});

function Cookiepolitik() {
  return (
    <PolicyLayout title="Cookiepolitik" updated="5. juli 2026">
      <PolicySection title="1. Hvad er cookies">
        <p>
          Cookies er små tekstfiler, der gemmes på din enhed, når du besøger en hjemmeside. Cookies
          gør det muligt at genkende din browser og gemme oplysninger om dit besøg. Denne politik
          beskriver, hvordan sklflow.com anvender cookies og lignende teknologier i henhold til
          cookiebekendtgørelsen og GDPR.
        </p>
      </PolicySection>

      <PolicySection title="2. Cookies vi anvender">
        <p>
          Vi anvender kun de cookies, der er strengt nødvendige for, at hjemmesiden fungerer. Disse
          cookies kræver ikke samtykke, jf. cookiebekendtgørelsens § 3, stk. 2.
        </p>
        <ul className="list-disc pl-6 space-y-1">
          <li>
            <strong>Sessions- og autentifikationscookies:</strong> Anvendes til at holde dig logget ind på
            din brugerkonto og opretholde din session sikkert.
          </li>
          <li>
            <strong>Sikkerhedscookies:</strong> Anvendes til at beskytte mod misbrug, spam og
            uautoriseret adgang.
          </li>
        </ul>
        <p>
          Vi anvender pt. ikke marketing-, tracking- eller analysecookies fra tredjepart. Hvis dette
          ændres, vil du blive bedt om samtykke, inden sådanne cookies aktiveres.
        </p>
      </PolicySection>

      <PolicySection title="3. Tredjeparter">
        <p>
          Enkelte funktioner på hjemmesiden leveres af tredjepartsudbydere (fx hosting, autentifikation
          og skrifttyper). Disse udbydere kan modtage tekniske oplysninger som f.eks. IP-adresse for
          at kunne levere tjenesten sikkert. Behandlingen sker i henhold til udbydernes egne
          privatlivspolitikker og vores databehandleraftaler.
        </p>
      </PolicySection>

      <PolicySection title="4. Dine valg">
        <p>
          Du kan til enhver tid slette eller blokere cookies i din browsers indstillinger. Bemærk, at
          hvis du blokerer strengt nødvendige cookies, kan dele af hjemmesiden — herunder login —
          holde op med at fungere.
        </p>
        <p>Vejledninger til de mest anvendte browsere:</p>
        <ul className="list-disc pl-6 space-y-1">
          <li>Google Chrome: support.google.com/chrome</li>
          <li>Mozilla Firefox: support.mozilla.org</li>
          <li>Apple Safari: support.apple.com</li>
          <li>Microsoft Edge: support.microsoft.com</li>
        </ul>
      </PolicySection>

      <PolicySection title="5. Behandling af personoplysninger">
        <p>
          Behandling af personoplysninger, der indsamles via cookies, sker i henhold til vores{" "}
          <a href="/privatlivspolitik" className="underline hover:no-underline">privatlivspolitik</a>.
        </p>
      </PolicySection>

      <PolicySection title="6. Kontakt">
        <p>
          Spørgsmål vedrørende vores brug af cookies kan rettes til emilsklanderandersen@gmail.com.
        </p>
      </PolicySection>

      <PolicySection title="7. Ændringer">
        <p>
          Denne cookiepolitik kan opdateres løbende. Den til enhver tid gældende version er
          tilgængelig på sklflow.com/cookiepolitik.
        </p>
      </PolicySection>
    </PolicyLayout>
  );
}
